import { render } from "./resume_manage.vue?vue&type=template&id=1d733245&scoped=true&ts=true"
import script from "./resume_manage.vue?vue&type=script&lang=ts"
export * from "./resume_manage.vue?vue&type=script&lang=ts"

import "./resume_manage.vue?vue&type=style&index=0&id=1d733245&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d733245"]])

export default __exports__